import { render, staticRenderFns } from "./rateManage.vue?vue&type=template&id=084328e9&scoped=true"
import script from "./rateManage.vue?vue&type=script&lang=js"
export * from "./rateManage.vue?vue&type=script&lang=js"
import style0 from "./rateManage.vue?vue&type=style&index=0&id=084328e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084328e9",
  null
  
)

export default component.exports